var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentVisaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 16.3579H8.94031L7.39576 10.292C7.32245 10.013 7.16679 9.76627 6.93782 9.65001C6.36639 9.35784 5.73672 9.12531 5.0498 9.00804V8.7745H8.36789C8.82583 8.7745 9.16929 9.12531 9.22653 9.53274L10.0279 13.9083L12.0867 8.7745H14.0892L11.0001 16.3579ZM15.234 16.3579H13.2888L14.8906 8.7745H16.8358L15.234 16.3579ZM19.3525 10.8753C19.4097 10.4669 19.7532 10.2334 20.1539 10.2334C20.7836 10.1747 21.4695 10.292 22.0419 10.5832L22.3854 8.95042C21.8129 8.71688 21.1833 8.59961 20.6119 8.59961C18.7238 8.59961 17.35 9.65002 17.35 11.1078C17.35 12.2169 18.3231 12.7992 19.0101 13.15C19.7532 13.4998 20.0394 13.7334 19.9822 14.0832C19.9822 14.6079 19.4097 14.8414 18.8383 14.8414C18.1514 14.8414 17.4645 14.6665 16.8358 14.3743L16.4924 16.0081C17.1793 16.2992 17.9224 16.4165 18.6094 16.4165C20.7263 16.4741 22.0419 15.4247 22.0419 13.8496C22.0419 11.8661 19.3525 11.7498 19.3525 10.8753ZM28.8498 16.3579L27.3053 8.7745H25.6462C25.3028 8.7745 24.9593 9.00804 24.8448 9.35784L21.9847 16.3579H23.9872L24.3869 15.2498H26.8473L27.0763 16.3579H28.8498ZM25.9324 10.8167L26.5039 13.6747H24.9021L25.9324 10.8167Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisaIcon);
export default __webpack_public_path__ + "static/media/Payment-visa-icon.6518df0d386fcbcee199d2d967c2415a.svg";
export { ForwardRef as ReactComponent };